// extracted by mini-css-extract-plugin
module.exports = {"list":"store-list_list__V0TdM","link":"store-list_link__a_RTE"};